export default "__VITE_PUBLIC_ASSET__7cc85312__"